import {
  ASQ_CATEGORIES,
  isNotDefined,
  type AsqCategory,
  type QuestionChoiceType,
  type QuestionData,
} from '@terros/common'
import { type SelectItem } from '../types'

export type QuestionStatus = 'archived' | 'draft' | 'scheduled' | 'active' | 'ended'

export const getQuestionStatus = (question: QuestionData, now: number = Date.now()): QuestionStatus => {
  if (question.isDeleted) return 'archived'
  if (isNotDefined(question.startDate)) return 'draft'
  if (now < question.startDate) return 'scheduled'
  if (isNotDefined(question.endDate) || now <= question.endDate) return 'active'
  return 'ended'
}

export const getReadableChoiceType = (choiceType: QuestionChoiceType): string => {
  switch (choiceType) {
    case 'YesNo':
      return 'Yes / No'
    case 'MultipleChoice':
      return 'Multiple Choice'
    case 'RatingScale':
      return 'Rating Scale (1-5)'
    default:
      return 'Unknown'
  }
}

export const getReadableCategory = (category: AsqCategory): string => {
  switch (category) {
    case 'ManagerEngagement':
      return 'Manager Engagement'
    case 'CompanyCulture':
      return 'Company Culture'
    case 'Product':
      return 'Product'
    case 'CareerDevelopment':
      return 'Career Development'
    case 'TeamDynamics':
      return 'Team Dynamics'
    default:
      return 'Unknown'
  }
}

export const CATEGORY_OPTIONS: SelectItem<AsqCategory>[] = ASQ_CATEGORIES.map((category) => ({
  label: getReadableCategory(category),
  value: category,
}))
